import { createContext, useContext, useEffect, useMemo, useState } from "react";

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const clearSession = () => {
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    setUser(null);
    setLoading(false);
  };

  const syncSession = () => {
    try {
      const access = localStorage.getItem("access");
      const storedUser = localStorage.getItem("user");

      if (!access || !storedUser || storedUser === "null" || storedUser === "undefined") {
        clearSession();
        return;
      }

      setUser(JSON.parse(storedUser));
    } catch {
      clearSession();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    syncSession();
  }, []);

  const setSession = (session) => {
    if (!session || !session.access || !session.user) {
      clearSession();
      return;
    }

    localStorage.setItem("access", session.access);

    if (session.refresh) {
      localStorage.setItem("refresh", session.refresh);
    } else {
      localStorage.removeItem("refresh");
    }

    localStorage.setItem("user", JSON.stringify(session.user));
    setUser(session.user);
    setLoading(false);
  };

  const value = useMemo(
    () => ({
      user,
      loading,
      setSession,
      clearSession,
      syncSession,
    }),
    [user, loading]
  );

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

export function useApp() {
  return useContext(AppContext);
}